import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SwiperComponent, SwiperConfigInterface } from 'ngx-swiper-wrapper';

interface Slide {
  button: any;
  image: string;
  image_alt_text?: string;
  image_desc?: string;
  image_heading: string;
  image_sub_heading: string | boolean;
  image_url: string | boolean;
  mobile_image: string;
  mobile_image_alt_text: string;
  type: string;
  text_color?: string;
}

@Component({
  selector: 'app-kv-carousel',
  templateUrl: './kv-carousel.component.html',
  styleUrls: ['./kv-carousel.component.scss']
})
export class KvCarouselComponent implements OnInit, AfterViewInit {
  @Input() data;

  @ViewChild('kvcontainer') kvContainer: ElementRef;
  @ViewChild('imageSwiper') imageSwiper: SwiperComponent;
  @ViewChild('thumbsSwiper') thumbsSwiper: SwiperComponent;
  public thumbsSwiperConfig: SwiperConfigInterface;
  public imageSwiperConfig: SwiperConfigInterface;

  currentLang = '';

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.thumbsSwiperConfig = {
      a11y: true,
      slidesPerView: 6,
      loop: false,
      centeredSlides: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      pagination: false,
      slideToClickedSlide: true,
      navigation: true,
      autoplay: false,
      speed: 1500
    };

    this.imageSwiperConfig = {
      a11y: true,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      grabCursor: true,
      slidesPerView: 1,
      spaceBetween: 0,
      autoplay: {
        delay: 6000
      },
      speed: 500,
      pagination: {
        el: null,
        clickable: true,
        type: 'bullets',
        renderFraction: function(currentClass, totalClass) {
          return (
            '<span class="' +
            currentClass +
            '"></span>' +
            ' of ' +
            '<span class="' +
            totalClass +
            '"></span>'
          );
        }
      }
    };

    this.currentLang = this.translate.currentLang;

    this.translate.onLangChange.subscribe(() => {
      this.currentLang = this.translate.currentLang;
    });
  }

  ngAfterViewInit() {
    if (this.kvContainer.nativeElement.querySelector) {
      const nextSlide = (this.kvContainer
        .nativeElement as HTMLElement).querySelector(
        '.gallery-images .swiper-button-next'
      );
      if (nextSlide) {
        nextSlide.addEventListener('click', () => this.playVideo());
      }

      const prevSlide = (this.kvContainer
        .nativeElement as HTMLElement).querySelector(
        '.gallery-images .swiper-button-prev'
      );
      if (prevSlide) {
        prevSlide.addEventListener('click', () => this.playVideo());
      }
    }
  }

  scrollToContainer($event) {
    const parentContainer =
      $event.target.parentElement.parentElement.parentElement;
    const scrollToEl = parentContainer.nextElementSibling;
    if (scrollToEl) {
      scrollToEl.scrollIntoView({ behavior: 'smooth' });
    }
    this.pauseVideo();
  }

  playOnThumb(autoplay) {
    this.pauseVideo();

    if (this.kvContainer.nativeElement.querySelector) {
      const activeVideo = (this.kvContainer
        .nativeElement as HTMLElement).querySelector(
        '.swiper-slide-active .kvcarousel__video'
      ) as HTMLVideoElement;

      if (autoplay === true) {
        // Avoid the Promise Error
        setTimeout(function() {
          activeVideo.play();
        }, 150);
      }
    }
  }

  pauseVideo() {
    const video = document.querySelectorAll('.kvcarousel__video');

    [].forEach.call(video, function(vid) {
      if (!vid.paused) {
        vid.pause();
      }
    });
  }

  playVideo() {
    this.pauseVideo();

    const imageIndex = this.imageSwiper.directiveRef.swiper().realIndex;
    const type = this.data.slides[imageIndex].type;

    if (type === 'video') {
      const autoplay = this.data.slides[imageIndex].auto_play;
      const video = (this.kvContainer
        .nativeElement as HTMLElement).querySelector(
        '.swiper-slide-active .kvcarousel__video'
      ) as HTMLVideoElement;
      if (autoplay === true) {
        // Avoid the Promise Error
        setTimeout(function() {
          video.play();
        }, 150);
      }
    }
  }

  enter() {
    this.imageSwiper.directiveRef.swiper().autoplay.stop();
  }

  leave() {
    this.imageSwiper.directiveRef.swiper().autoplay.start();
  }

  getSlideTextColor(slide: Slide): string | null {
    return slide.text_color || null;
  }
}
